import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { TelemetryService } from './app/common/services/app-insights.service';
import { ErrorHandler, mergeApplicationConfig } from '@angular/core';
import { ErrorHandlerService } from './app/common/errorhandler/error-handler.service';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { routes } from './app/app.routes';

const appInsightsConfig = {
  providers: [
    TelemetryService,
    { provide: ErrorHandler, useClass: ErrorHandlerService }
  ]
};

bootstrapApplication(AppComponent, 
  mergeApplicationConfig(appConfig, appInsightsConfig, {
  providers: [provideAnimationsAsync(), provideRouter(routes)]
}))
  .catch((err) => console.error(err));